export default __webpack_public_path__ + "static/media/transform-lifes-3-colombia.636c39e8.png";